import {companyLessor} from '@drivesally/sally-fn/lib/vehicle/constants';

export default ({vehicle: {owner = ''} = {}} = {}) =>
  !!companyLessor[owner] ? companyLessor[owner] : 'Drive Sally';
